export const selectFiltersState = (state) => state.views.myTradera.filters;
